import { Accessibility, Co2, SpaOutlined } from '@mui/icons-material';
import { Stack } from '@mui/material';

import { ScoreType } from '@/domain/impact/impact.entity';
import { language } from '@/ui/i18n';
import { ColorsRaw } from '@/ui/theme/colors-raw';
import { Fonts } from '@/ui/theme/fonts';
import { getColorForScore } from '@/ui/utils/get-color-for-score';

import { TopicScoreDetailsData } from '../type';

export function IconScoreBadge({
  type,
  data,
}: {
  type: ScoreType;
  data: TopicScoreDetailsData;
}) {
  let badgeBackgroundColor = ColorsRaw.scores.Anthracite_4;
  let badgeColor = ColorsRaw.basic.White;
  switch (type) {
    case 'co2':
      badgeBackgroundColor = 'grey';
      badgeColor = 'white';
      break;
    case 'ess':
      badgeBackgroundColor = getColorForScore(data?.scoreLetter || '').main;
      badgeColor = getColorForScore(data?.scoreLetter || '').text;
      break;
    case 'env':
      badgeBackgroundColor = getColorForScore(data?.scoreLetter || '-').main;
      badgeColor = getColorForScore(data?.scoreLetter || '-').text;
      break;
  }
  return (
    <Stack
      sx={{
        minWidth: 90,
        height: 64,
        px: 1,
        borderRadius: '18px',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 1,
        // text
        fontSize: 32,
        fontWeight: 'bold',
        fontFamily: Fonts.DarkerGrotesque,
        // color
        color: badgeColor,
        backgroundColor: badgeBackgroundColor,
      }}
    >
      {type === 'co2' && (
        <>
          <Co2 />
          {data?.value.toLocaleString(language) || 0}
        </>
      )}
      {type === 'ess' && (
        <>
          <Accessibility />
          {data?.scoreLetter}
        </>
      )}
      {type === 'env' && (
        <>
          <SpaOutlined />
          {data?.scoreLetter}
        </>
      )}
    </Stack>
    // </Box>
  );
}
